import "#vendor/autosize.js";

jQuery(function () {
  jQuery("textarea").each(function () {
    autosize(this);
  });
});

// Catch textareas added to the page dynamically
jQuery(document).on("focus", "textarea", function () {
  autosize(this);
});
